"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Reload = _interopRequireDefault(require("@ucloud/ucloud-icons/dist/uc-action/svgr/Reload"));

var _Item = _interopRequireDefault(require("./Item"));

var _Text = _interopRequireDefault(require("../Typography/Text"));

var _style = require("./style");

var _excluded = ["value", "count", "onRefresh"];

var _this = void 0;

/**
 * ChargeInfo.Quotas
 * @description 计费UI组件-配额信息
 */
var Quotas = function Quotas(_ref) {
  (0, _newArrowCheck2["default"])(this, _this);
  var value = _ref.value,
      count = _ref.count,
      onRefresh = _ref.onRefresh,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isOverQuotas = (0, _parseInt2["default"])(count) > (0, _parseInt2["default"])(value);
  return /*#__PURE__*/_react["default"].createElement(_Item["default"], others, /*#__PURE__*/_react["default"].createElement(_style.StyledQuotasValueWrapper, {
    onRefresh: onRefresh
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: isOverQuotas ? "error" : "light",
    size: "t1"
  }, count), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "light",
    size: "t1",
    className: "".concat(_style.prefixCls, "-quotas-value")
  }, "/", value), onRefresh && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "light",
    size: "t1",
    className: "".concat(_style.prefixCls, "-quotas-refresh")
  }, /*#__PURE__*/_react["default"].createElement(_Reload["default"], {
    onClick: onRefresh
  }))));
}.bind(void 0);

Quotas.propTypes = {
  /** 配额的标题 */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** 配额的标题尺寸 */
  labelSize: _propTypes["default"].oneOf(["sm", "md", "lg"]),

  /** 配额的间距尺寸 */
  marginSize: _propTypes["default"].oneOf(["xs", "sm", "md", "lg", "xlg"]),

  /** 配额数量 */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** 购买数量 */
  count: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** 刷新回调 */
  onRefresh: _propTypes["default"].func
};
Quotas.defaultProps = {
  labelSize: "sm",
  marginSize: "xs"
};
var _default = Quotas;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/Quotas.js
// module id = 2083
// module chunks = 6 7 17 18